import { HouseholdError } from '../../data/household';

// Kody z API, dla których warstwa danych nie ma własnego komunikatu (albo ma zbyt ogólny).
const MESSAGES: Record<string, string> = {
  bad_email: 'To nie wygląda na poprawny adres e-mail.',
  mail_failed: 'Nie udało się wysłać e-maila z zaproszeniem. Spróbuj ponownie za chwilę.',
  last_member: 'Jesteś jedyną osobą w tym domu.',
  other_members: 'Masz już wspólny dom z innymi osobami. Żeby dołączyć, najpierw opuść obecny dom (zakładka Dom).',
  used: 'To zaproszenie zostało już wykorzystane albo odrzucone.',
  household_changed: 'Dom właśnie się zmienił. Spróbuj jeszcze raz.',
};

export const errorCode = (e: unknown): string => (e instanceof HouseholdError ? e.code : 'unknown');

export function householdErrorMessage(e: unknown): string {
  if (e instanceof HouseholdError) return MESSAGES[e.code] ?? e.message;
  if (e instanceof Error && e.message) return e.message;
  return 'Coś poszło nie tak. Spróbuj ponownie.';
}
